module.exports = __webpack_public_path__ + "assets/img/24_1069_big.6af54d5d.jpg";